import { graphql } from '~/gql';

export const JobTemplateFields = graphql(`
  fragment JobTemplateFields on JobTemplate {
    id
    isStarter
    status
    name
    behavior
    quickCreate
    tags {
      id
      entityType
      category
      name
      description
      colour
    }
    notes
    includeAttributes
    jobAttributeIds
    attachments {
      id
      kind
      ext
      thumb
      url
      originalFilename
    }
    guestyCleaningStatus
    tasks {
      id
      type
      name
      description
      tags {
        nodes {
          id
          entityType
          name
          category
          description
          colour
        }
      }
      attributes {
        id
        type
        category
        name
        value
      }
      jobAttributeIds
      attribute {
        id
        attributes
      }
      purchase {
        id
        spaces
      }
      stocktake {
        ...StocktakeTaskFields
      }
      config {
        selection
        spaces
        assetTypes
        allow
        shareAttributes
        shareJobHistory
        shareDeploymentHistory
      }
      assets {
        id
        name
        type
      }
    }
  }
`);
